<mini-tabs :data="data"><template v-slot:default="slotProps"><obligation-card :info="slotProps.tabData"></obligation-card></template></mini-tabs>